import { useDebugValue } from 'react';
import { useFieldState } from '../../../contexts';

export const useConditionalContentErrors = () => {
  const { error } = useFieldState('conditionalContent');
  useDebugValue(error);
  return error;
};
